<template>
	<div>
    <div class="row" style="padding-bottom: 25px;">
        <template v-if="items.length > 0">
            <div class="col s2 leftlabel">{{$t('inner_inspections.date')}}</div>
            <div class="col s3 leftlabel">{{$t('documents.description')}}</div>
        </template>
    </div>
    <template v-for="(doc, index) in items">
        
    
    <div class="row" >
         <div class="col s2 input-field">
            <input type="date" class="datepicker" v-model="doc.date" :disabled="doc.edit == false">
            {{doc.errors ? doc.errors.date[0] : ""}}
        </div>
        <div class="col s3  input-field">
            <input v-model="doc.comment" :disabled="doc.edit == false" :placeholder="$t('settings.documents.description_placeholder')" />
        </div>
        <div class="col s3" :class="{'docselector': (doc.file == undefined && doc.url == undefined)}" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
            <label :for="'docs'+index" v-if="!doc.url">{{doc.file == undefined ? "Wybierz plik..." : doc.file.name}}</label>
            <input type="file" :id="'docs'+index" @change="setFile(doc, $event.target.name, $event.target.files)" v-if="!doc.url" hidden />
            <a :href="doc.url" v-if="doc.url">
                <i class="material-icons">insert_drive_file</i>
            </a>
            

        </div>
        <div class="col s4">
            <a v-on:click="editDocument(doc)" class="waves-effect waves-light btn-large emptygreen" v-if="!doc.edit">
                        <template>{{$t('menu.buttons.edit')}}</template>
                    </a>
            <a v-on:click="saveDocument(doc)" class="waves-effect waves-light btn-large emptygreen" v-if="doc.edit">
                    <div v-if="doc.saving" class="preloader-wrapper small active">
                         
                    </div>
                    {{doc.saving == false ? $t('menu.buttons.save_changes') : ""}}
            </a>
            <a v-on:click="cancelEditDocument(doc)" class="waves-effect waves-light btn-large cancelbutton" v-if="doc.edit">
                    <div v-if="doc.saving" class="preloader-wrapper small active">
                         
                    </div>
                    {{doc.saving == false ? $t('menu.buttons.cancel_changes') : ""}}
            </a>
            <a v-on:click="removeDocument(doc)" class="waves-effect waves-light btn-large cancelbutton" v-if="doc.id">
                    x
            </a>
             <button v-if="doc.url" class="waves-effect waves-light btn-large green" v-on:click="openDocument(doc)">
             Podgląd
         </button>
        </div>
       </div>
        <div class="row" v-if="doc.opened">
         <div class="col s12">
            <object style="width: 100vw; height: 50vh;" :data="doc.url" type="application/pdf"></object>

         </div>
        </div>
       </template>
       <div  v-if="load"  class="container" style="width: 3%; margin: auto;">
	        <preloader v-if="load" n="7"/>
       </div>
        <div class="row" style="margin-bottom: 8px; margin-top: 8px;">
        	 	<div class="col s3" style="margin-bottom: 15px;">
                    <a v-on:click="addInnerInspection()" class="waves-effect waves-light btn-large green">{{$t('place.add_inner_inspection')}}</a>
                </div>
        </div>
        <div class="row" style="margin-bottom: 8px; margin-top: 8px;">
           
           
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import _ from 'lodash';
export default {
  data: function () {
    return {items: [], load: false, editdocuments: false, savingdocuments: false};
  },
  mounted: async function(){
    this.load = true;
  	var response = await axios.get("/customers/"+this.customer_id+"/places/"+this.place.id+"/inner_inspections.json");
  	this.items = response.data
    for (var i = this.items.length - 1; i >= 0; i--) {
        var item = this.items[i];
        item.edit = false;
        item.opened = false;
    }
  	this.load = false;

  },
methods: {
	addInnerInspection: function(){
		this.items.push({date: new Date().toISOString().slice(0, 10), comment: "", file: undefined, url: undefined, edit: true, saving: false});
		
		this.$forceUpdate();
	},
    editDocument: function(doc){
        doc.edit = true
        doc.saving = false
        this.$forceUpdate();
    },
	cancelEditDocument: function(doc){
        doc.edit = false;
        if(doc.id){

        }else{
            this.items = this.items.filter(d => d !== doc);
        }
		this.$forceUpdate();
	},
    setFile: function(doc, name, file) {
        doc.file = file[0];
        this.$forceUpdate();
    },
    saveDocument: async function(item){
        if(item.saving == true) return;
        item.saving = true;
        
        const formData = new FormData();
        if (item.id) formData.append('inner_inspection[id]', item.id);
        formData.append('inner_inspection[comment]', item.comment);
        formData.append('inner_inspection[date]', item.date);
        
        if (item.file) formData.append('inner_inspection[attachment]', item.file);
        if(item.id){
            try{
                var response = await axios.put('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/inner_inspections/'+item.id+'.json', formData)
                item.edit = false;
                item.url = response.data.attachment.url;
                item.id = response.data.id;
                item.opened = false;
                this.$forceUpdate();
            }catch(err){
                item.errors = err.response.data.errors;
                this.$forceUpdate();
            }
        }else{
            try{
                var response = await axios.post('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/inner_inspections.json', formData);
                item.edit = false;
                item.url = response.data.attachment.url;
                item.id = response.data.id;
                item.opened = false;
                this.$forceUpdate();
            }catch(err){
                item.errors = err.response.data.errors;
                this.$forceUpdate();
            }
        }
        item.saving = false;
    },
    openDocument: function(item) {
        item.opened = true;
        this.$forceUpdate();
    },
    removeDocument: async function(item) {
        if(!confirm("Czy chcesz usunąć kartę kontroli wewnętrznej ?")) return
        try{
            var response = axios.delete('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/inner_inspections/' + item.id + '.json')
            this.items = this.items.filter(d => d !== item);
        }catch(err){

        }
    }
},
   props: { customer_id: [String, Number], place: Object},
  computed: {
   
  },
  
}
</script>
<style scoped>
div {
  margin-left: auto;
  left: auto;
  right: auto;
  line-height: 2;
}
</style>